// extracted by mini-css-extract-plugin
export default {"box":"model-upload-handler_box__WUaxX"};